import { george, theme } from "aaa";
import * as i18n from "i18n/util";
import * as React from "react";

type ContinueButtonProps = {
    messageId: i18n.IDS;
    onClick: () => void;
};

export const ContinueButton = ({ messageId, onClick }: ContinueButtonProps) => (
    <george.ActionButton
        messageId={messageId}
        onClick={onClick}
        style={{ bottom: theme.ACTION_BUTTON_HEIGHT + theme.MARGIN }}
        buttonStyle={{
            borderRadius: theme.BORDER_RADIUS_FULL,
            fontSize: 18,
        }}
    />
);



// WEBPACK FOOTER //
// ./src/components/gJunior/components/ContinueButton.tsx